import { render } from "./HP.vue?vue&type=template&id=3ed3a9b3&scoped=true"
import script from "./HP.vue?vue&type=script&lang=js"
export * from "./HP.vue?vue&type=script&lang=js"

import "./HP.vue?vue&type=style&index=0&id=3ed3a9b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed3a9b3"]])

export default __exports__